module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA8CAMAAAAqjKioAAAAJ1BMVEVMaXH////////////////////////////////////////////////c+C/6AAAADHRSTlMAwIBAkGDg8CCg0DBCQor2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAeklEQVRIie3WSw6AIAxAQVoEv/c/rwsNUUuRokFi+tazaAkJGCPJLndhJQyJKVGIAfdcBg7B23gbYzziDkinBW0x5seoin+/oAgDvfU8dkhqfsGy04AM3MjMihUr/gz39IUI+SvO+m/IMTMiqTb28WOZopjvER5sonkFQpod8hfxVJMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_wenquandiaocha.png
// module id = 0lYx
// module chunks = 1